import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['field', 'prepaid', 'question', 'rest']

  connect() {
    if (this.fieldTarget.value && this.fieldTarget.value !== 'undefined' ) { this.show(this.fieldTarget.value); }
  }

  check(event) {
    if (event.target.value == 'prepaid') {
      this.show('prepaid');
    } else if (event.target.value == 'question') {
      this.show('question');
    }
  }

  show(tariff) {
    this.questionTarget.classList.add('hidden');
    this.prepaidTarget.classList.add('hidden');

    if (tariff == 'prepaid') {
      this.prepaidTarget.classList.remove('hidden')
    } else if (tariff == 'question') {
      this.questionTarget.classList.remove('hidden')
    }

    this.restTarget.classList.remove('hidden');
  }
}
